import React, { useEffect, useState } from 'react';
import client from '../../api/client';
import { useAlert } from '../../context/AlertContext';
import { TrashIcon } from '@heroicons/react/24/outline';

export default function AddKeywords() {
	const [keywords, setKeywords] = useState([]);
	const { setAlert } = useAlert();

	useEffect(() => {
		getKeywords();
		// Analytics.pageViewEvent('Admin:Keywords', { keywords });
	}, []);

	const getKeywords = async () => {
		try {
			const response = await client.get('/admin/keywords');
			setKeywords(response.data.keywords.map((keyword) => keyword.word));
		} catch (error) {
			console.error(error);
		}
	};

	const handleSubmit = async (e) => {
		e.preventDefault();
		try {
			await client.post('/admin/keywords', { keywords });
			setAlert('success', 'Keywords updated successfully');
		} catch (error) {
			setAlert('error', 'Error updating keywords');
			console.error(error);
		}
	};

	const addField = () => {
		setKeywords(['', ...keywords]);
	};

	const removeField = (index) => {
		setKeywords(keywords.filter((_, i) => i !== index));
	};

	const handleInputChange = (index, event) => {
		const newKeywords = [...keywords];
		newKeywords[index] = event.target.value;
		setKeywords(newKeywords);
	};

	return (
		<div className='overflow-scroll max-h-[80vh] w-full max-w-2xl mx-auto my-2 p-6 bg-gray-200 rounded-lg shadow-lg text-black space-y-6'>
			<h1 className='text-2xl font-bold'>Manage Keywords</h1>
			<h3>{keywords.length} Keywords</h3>

			<div className='flex justify-between'>
				<button
					onClick={addField}
					className='rounded bg-secondary-600 px-4 py-1 text-sm font-semibold text-white shadow-sm hover:bg-secondary-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-secondary-600'
				>
					Add Keyword
				</button>
				<button
					onClick={handleSubmit}
					className='rounded bg-emerald-600 px-4 py-1 text-sm font-semibold text-white shadow-sm hover:bg-emerald-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-emerald-600'
				>
					Save Changes
				</button>
			</div>

			{keywords.map((keyword, index) => (
				<div
					key={index}
					className='flex items-center space-x-4'
				>
					<input
						type='text'
						value={keyword}
						onChange={(e) => handleInputChange(index, e)}
						className='w-full rounded-md px-2 py-1 text-black border border-gray-300 shadow-sm focus:ring-2 focus:ring-secondary-600'
						placeholder={`Keyword ${index + 1}`}
					/>
					<button
						onClick={() => removeField(index)}
						className='p-1 rounded bg-red-600 text-white hover:bg-red-700'
					>
						<TrashIcon className='h-5 w-5' />
					</button>
				</div>
			))}
		</div>
	);
}
